import type { LastFirehoseParams } from '../close-bridge-connection.js';

export function proxyPortsEqual(a: number[], b: number[]): boolean {
  if (a.length !== b.length) return false;
  const sa = [...a].sort((x, y) => x - y);
  const sb = [...b].sort((x, y) => x - y);
  return sa.every((v, i) => v === sb[i]);
}

export function sameFirehoseBridge(a: LastFirehoseParams, b: LastFirehoseParams): boolean {
  return (
    a.firehoseServerUrl === b.firehoseServerUrl &&
    a.workspaceId === b.workspaceId &&
    a.bridgeName === b.bridgeName
  );
}

/** Same bridge target and socket still open — only proxy ports may need updating. */
export function shouldReuseOpenFirehoseConnection(
  prev: LastFirehoseParams | null | undefined,
  next: LastFirehoseParams,
  isConnected: () => boolean,
): boolean {
  return Boolean(prev && sameFirehoseBridge(prev, next) && isConnected());
}
